module.exports = __webpack_public_path__ + "static/media/Zorggroep_Marijke.683fbc5c.svg";